
<template>
	<div class="nav-bar">
		<img src="@/assets/img/select.png" @click="back"/>
		<div>{{title}}</div>
	</div>
</template>
<script>
export default{
	props:{
		title:{
			type:String,
			default:"title"
		}
	},
    methods:{
        //返回
        back(){
			try{
				window.history.go(-1)
			}catch(err){
				this.UTILS.backHome();
			}
        }
    }
}
</script>

<style scoped>
	.nav-bar{
		position: sticky;
		top: 0;
		padding:0 0.4rem 0 0.4rem;
		width: 100%;
		height: 0.88rem;
		display: flex;
		align-items: center;
		color: #000000;
		background: #FFFFFF	;
		font-size: 0.30rem;
		z-index: 9;
	}
	.nav-bar img{
		width: 0.4rem;
		transform: rotate(90deg);
	}
	.nav-bar div{
		flex: 1;
		text-align: center;
	}
</style>
